/**
 * @file: util.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const calculateScoreViewDimension = (width: number, height: number) => {
  const a = 1 + Math.sqrt(2) / 2;

  // a*r0 <= h, 2 * r0 <= w
  let r0 = height / a;
  if (2 * r0 > width) {
    r0 = width / 2;
  }

  return {
    width: r0 * 2,
    height: r0 * a,
  };
};
